<template>
  <!-- 一旦共通化するのは後回し（時間があれば） -->
  <div class="shipping_wrap bg_white mt12 pt16 pb16">
    <h2 class="content_title">配送時間指定</h2>
    <div class="select_wrap bdb pl16 pr20 mt24 pb5 bottom_arrow" :class="{ 'disable_arrow' : checkBcChangeTime }">
      <!-- <select name="shipping" id="" class="shipping_time rb c5a"> -->
        <select name="shipping" id="" class="shipping_time rb c5a" v-model="timeData.deliveryTimeId" :disabled="checkBcChangeTime">
        <option v-bind:value="value.deliveryTimeId" v-for="value in shippingTime">{{ value.deliveryTimeName }}</option>
      </select>
    </div>
    <p class="select_time_text  ar pr15 mt5" v-if="availableBulkSetting">
      {{ checkBcChangeTime ? 'お届け時間の設定変更はBC001からとなっております。' : '他のBCにもこのお届け時間が適応されます。' }}
    </p>
    <div class="shipping_address bdb mt24">
      <h2 class="content_title">配送住所</h2>
      <div class="address_detail right_arrow pl16 pr20 mt24 pb5" v-on:click="selectAddress()">
        <p v-if="!delivaryAddressData.sameWithBc001 || !delivaryAddressData.recipientName" class="shipping_name rb c5a">{{ delivaryAddressData.recipientName }}</p>
        <p v-if="!subscriptionDeliveryAddressViewSameWithBc001" class="address rr c5a"><span class="zip" v-if="delivaryAddressData.zipCode">〒{{ delivaryAddressData.zipCode }}</span> <span class="address_text">{{delivaryAddressData.prefectureName + delivaryAddressData.address }}</span></p>
        <!-- store用  <p v-if="delivaryAddressData.recipientName" class="shipping_name rb c5a">{{ delivaryAddressData.recipientName }}</p>
        <p class="address rr c5a"><span class="zip" v-if="delivaryAddressData.zipCode">〒{{ delivaryAddressData.zipCode }}</span> <span class="address_text">{{delivaryAddressData.prefectureName + delivaryAddressData.address }}</span></p> -->
        <p class="sameWithBc rr c5a" v-if="subscriptionDeliveryAddressViewSameWithBc001">※BC001の配送住所情報を使用します。</p>
      </div>

    </div>
    <!-- 配送先住所選択画面 -->
    <SelectAddress ref="openDeriveryAddress" @deliveryAddressData="sendAddress" />
  </div>
</template>

<script>
import SelectAddress from '@/components/subscription/SelectAddress'
import RepeatOrder from '@/components/api/repeatOrder'
// import DeliveryAddress from '@/components/api/deliveryAddress'
import scrollPosition from '@/model/scrollPosition';
import { mapGetters } from 'vuex';


export default {
  components: {
    SelectAddress,
  },
  data() {
    return {
      timeName: '',
      timeData: {
        deliveryTimeId: null,
        deliveryTimeName: '',
      },
      shippingTime: [],
      nowBC: localStorage.getItem('subNowBC'),
      availableBulkSetting: false,
      delivaryAddressData: {
        recipientName: '',
        deliveryAddressId: null,
        zipCode: '',
        prefectureName: '',
        address: '',
        sameWithBc001: ''
      },
    }
  },
  methods: {
    selectAddress() {
      scrollPosition.open();
      this.$refs.openDeriveryAddress.isShow();
    },
    sendAddress(data) {
      console.log(data);
      if(data.deliveryAddressId != 0) {
        this.delivaryAddressData.deliveryAddressId = data.deliveryAddressId;

      }
      this.delivaryAddressData.recipientName = data.recipientName;

      this.delivaryAddressData.zipCode = data.address.zipCode;
      this.delivaryAddressData.prefectureName = data.address.prefecture.prefectureName;
      this.delivaryAddressData.address = data.address.address;

      this.delivaryAddressData.sameWithBc001 = data.sameWithBc001;

      this.$emit('deliveryAddressData', this.delivaryAddressData);
    },
    async apiRepeatGetDeliveryTimeList() {
      await RepeatOrder.repeatGetDeliveryTimeList().then((val) => {
        this.availableBulkSetting = val.availableBulkSetting;
        this.shippingTime.push(...val.deliveryTimeList);

        let userDetail = JSON.parse(localStorage.getItem('userDetail'));
        if (userDetail) {
          this.timeData.deliveryTimeId = userDetail.deliveryTimeData.deliveryTimeId;
          this.timeData.deliveryTimeName = userDetail.deliveryTimeData.deliveryTimeName;
        } else {
          this.timeData.deliveryTimeId = val.selectedDeliveryTimeId;
          let index = this.shippingTime.findIndex((value) => value.deliveryTimeId == val.selectedDeliveryTimeId);
          this.timeData.deliveryTimeName = this.shippingTime[index].deliveryTimeName;
        }
        this.$store.dispatch('commitUserDetailAvailableBulkSetting', { availableBulkSetting: this.availableBulkSetting })
        this.$store.dispatch('commitUserDetailDeliveryTimeData', { deliveryTimeId: this.timeData.deliveryTimeId, deliveryTimeName: this.timeData.deliveryTimeName });

      });
    },
    // editAddressDefault() {
    //   // 編集時に選択した住所を表示させる
    //   let addressSelectNumber = localStorage.getItem('addressSelectNumber');
    //   if (addressSelectNumber != null) {
    //     this.address.selectNumber = addressSelectNumber;
    //   }
    // },

  },
  computed: mapGetters([
    'subscriptionDeliveryAddressViewSameWithBc001',
    'userDetail'
  ]),
  computed: {
    checkBcChangeTime() {
      return this.availableBulkSetting === true && this.nowBC !== "001";
    }
  },
  created () {
    // this.apiGetdeliveryAddress();
    this.apiRepeatGetDeliveryTimeList();
    // this.editAddressDefault();
  },
  watch: {
    timeData: {
      deep: true,
      handler() {
        let index = this.shippingTime.findIndex((value) => value.deliveryTimeId == this.timeData.deliveryTimeId);
        this.timeData.deliveryTimeName = this.shippingTime[index].deliveryTimeName;
        this.$store.dispatch('commitUserDetailDeliveryTimeData', { deliveryTimeId: this.timeData.deliveryTimeId, deliveryTimeName: this.timeData.deliveryTimeName });
        this.$emit('deliveryData', this.timeData);
      }
    }
  }
}
</script>

<style lang="css" scoped>
.sameWithBc {
  /* color: red; */
  /* font-size: 13px; */
  font-size: 15px;
}
.content_title {
  width: 123px;
}
.shipping_time {
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
}

.shipping_time {
  border: none;
  font-size: 16px;
  width: 100%;
}

.right_arrow, .bottom_arrow {
  padding-right: 45px;
}

.nselection_text {
  font-size: 15px;
}

.select_wrap.disable_arrow::after {
  content: none;
}

.select_time_text {
  font-size: 12px;
  color: #009FA9;
  text-align: right;
}
</style>



// WEBPACK FOOTER //
// src/components/subscription/Shipping.vue